import React, {useState, useEffect, Fragment} from 'react';
import * as PropTypes from 'prop-types';
import LoginForm from '../LoginForm';
import CreateUserForm from '../CreateUserForm';
import Button from '../../shared/Button';
import styled from 'styled-components';
import colors from '../../../lib/Colors';
import fonts from '../../../lib/Fonts';
import Breakpoints from '../../../lib/Breakpoints'

const Wrapper = styled.div`
  width: 380px;
  @media (max-width: ${Breakpoints.phone}) {
    padding: 5px;
    width: 95%;
   }
`;

const ButtonWrapper = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.lighterGray};
  width: 160px;
`;

const AuthSwitcherButton = styled(Button)`
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.9px;
  color: ${colors.almostBlack};
  background: transparent;
  outline: 0;
  margin-bottom: -3px;
  width: auto;
  border: none;
  padding-bottom: 8px;
  border-radius: 0;
  &:disabled {
    color: ${colors.almostBlack};
    background: transparent;
    padding-bottom: 3px;
    border-bottom: 5px solid ${colors.colorEmphasis}; /*TODO: Add to Colors*/
    cursor: default;
  }
`

const FormHeader = styled.h2`
  font-size: 1.75em;
  color: ${colors.almostBlack};
  font-family: ${fonts.family.workSans};
  margin: 0 0 1em;
  font-weight: 300;
`;

const AuthFormWrapper = ({isLoginForm, createRetailer, hasInviteLink}) => {
  const [isLogin, setIsLogin] = useState(isLoginForm);
  useEffect(() => {
    if (hasInviteLink) {
      setIsLogin(false)
    }
  }, [hasInviteLink])
  return (
    <Wrapper>
      {!createRetailer ? (<ButtonWrapper>
        <AuthSwitcherButton
          data-test-id={'createUserButton'}
          disabled={!isLogin}
          onClick={() => setIsLogin(false)}
        >
          SIGN UP
        </AuthSwitcherButton>
        <AuthSwitcherButton
          data-testid={'loginButton'}
          disabled={isLogin}
          onClick={() => setIsLogin(true)}
        >
          LOG IN
        </AuthSwitcherButton>
      </ButtonWrapper>) : null}
      {isLogin ? (
        <Fragment>
          <FormHeader>
            Log in
          </FormHeader>
          <LoginForm/>
        </Fragment>
      ) : (
        <Fragment>
          <CreateUserForm skipRetailer={hasInviteLink}/>
        </Fragment>
      )}
    </Wrapper>
  );
};

AuthFormWrapper.propTypes = {
  createRetailer: PropTypes.bool,
  hasInviteLink: PropTypes.bool,
  isLoginForm: PropTypes.bool,
  signIn: PropTypes.func
};

export default AuthFormWrapper;
